module.exports = "<img [src]=\"URL\" style=\"width: 100%\">"